<template>
	<div class="l-body">
		<Top/>
	<div class="wrap zhuizong">
	<div class="l-wrap zheng" style="margin-top:300px">
	<div class="help-menu-box">
	<h1>游戏产品列表</h1>
	<div class="st_tree">
	<ul>
	<li @click="an(1)"><a>客户端游戏</a></li>
	<ul class="tree_n" v-show="s1">
	<li v-for="data in objData" v-if="data.type==1"><a target="_blank" @click="getlist(data.id)">{{data.game}}</a></li>
	</ul>
	<!-- <li @click="an(2)"><a>网页游戏</a></li>
	<ul class="tree_n" v-show="s2">
	<li v-for="data in objData" v-if="data.type==2"><a target="_blank" @click="getlist(data.id)">{{data.game}}</a></li>
	</ul>
	<li  @click="an(3)"><a>手机游戏</a></li>
	<ul class="tree_n" v-show="s3">
	<li v-for="data in objData" v-if="data.type==3"><a target="_blank" @click="getlist(data.id)">{{data.game}}</a></li>
	</ul> -->
	</ul>
	</div>
	</div>
	<div class="help-jl-box">
	<div class="m_top">
	<div class="jilu">
	<span>工单查询：</span>
	<div>
	<div class="select">
	<el-select placeholder="请选择时间" v-model="choose" @change="handleChange($event)">
	<el-option value="近三个月记录">近三个月记录</el-option>
	<el-option value="近六个月记录">近六个月记录</el-option>
	<el-option value="近12个月记录">近12个月记录</el-option>
	<el-option value="近24个月记录">近24个月记录</el-option>
	</el-select>
	</div>
	<div class="selects">
	<el-select placeholder="工作状态" v-model="choose1" @change="handleChange1($event)">
	<el-option value="未审核">未审核</el-option>
	<el-option value="已拒绝">已拒绝</el-option>
	<el-option value="已完成">已完成</el-option>
	<el-option value="问题受理中">问题受理中</el-option>
	</el-select>
	</div>
	</div>
	<div class="gdok"><a @click="shou">确定</a></div>
	</div>
	</div>
	<h1>服务记录追踪</h1>
	<div class="xiangxi">
	<table class="biaoge" v-for="data in listData">
	<tr>
	<th colspan="4"><p class="youp"><span id="">{{data.create_time}}</span><span id="liushui">流水号：{{data.turnover}}</span></p><p class="zuop"><span id="level">{{isVip(data.vip)}}</span></p></th>
	</tr>
	<tr>
	<td width="40%">
	<p class="gamename">游戏名称：{{data.game}}</p>
	<p class="ywutype">业务类型：{{data.tablename}}</p>
	</td>
	<td>
	<p class="jindu">处理进度</p>
	<p class="jindu2">{{jd(data.csc)}}</p>
	</td>
	<td>
	<p class="jindu">消息状态</p>
	<p class="jindu2"><span :class="data.usernew==0?'':'red'">{{msg(data.usernew)}}</span></p>
	</td>
	<td class="jindu3">
	<a @click='to(data)'>查看详情</a>
	</td>
	</tr>
	</table>
	<div class="newstab">
		<el-pagination
		  @current-change="handleCurrentChange"
		  :page-size="6"
		  layout="prev, pager, next"
		  :total="total">
		</el-pagination>
	</div>
	</div>
	<div class="hujiao">
	<p>您的问题是否得到了解决？如果没有，您可以尝试：</p>
	<p>呼叫在线客服：<a href='http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDEwMzM3N180NTIzMjdfODAwMTAzMzc3XzJf'>在线客服</a></p>
	</div>
	</div>
	</div>
	</div>
	</div>
</template>

<script>
	import Top from '@/components/top.vue'
	export default {
	  name: "tracklist",
	  components: {
	    Top
	  },
	  data () {
	    return {
	      objData:[{id: 4, game: "仙境传说起源", type: "1", order: 5, show: null}],
	      page:1,
		  s1:false,
		  s2:false,
		  s3:false,
		  listData:[],
		  id:this.$route.query.gid,
		  total:0,
		  word:'',
		  choose:'',
		  choose1:'',
		  time:'',
		  csc:''
	    }
	  },
	  created() {
	    //this.getGameName()
		this.getList()
	  },
	  methods:{
	  	// getGameName() {
	  	//   this.$axios({
	  	//     method: 'get',
	  	//     url: '/index.php/user/User/index'
	  	//   }).then(res => {
	  	//     if(res.data.status==200){
	  	//     this.objData=res.data.data
	  	//     }
	  	//   })
	  	// },
		msg(num){
			if(num==1){
				return"您有未读消息"
			}else{
				return"无未读消息"
			}
		},
		isVip(meg){
			if(meg=="true"){
				return"贵宾用户"
			}else if(meg=='false'||meg==''){
				return"非贵宾用户"
			}else{
        return meg
      }
		},
		handleCurrentChange: function(currentPage){
		  this.page = currentPage;
		  this.getList()
		},
		jd(num){
			if(num==0){
				return"未审核"
			}else if(num==1){
				return"工单处理中"
			}else if(num==2){
				return"客服处理中"
			}else if(num==3){
				return"已拒绝"
			}else if(num==4){
				return"已完成"
			}else if(num==5){
				return"问题受理中"
			}else if(num==6){
        return"跟进中"
      }
		},
		getlist(num){
			this.page=1
			this.id=num
			this.getList()
		},
		getList(){
			if(this.id){
				this.$axios({
				  method: 'get',
				  url: '/index.php/user/User/playerform',
				  params: {
				    game_id:this.id,
            page:this.page
				  }
				}).then(res => {
				  if(res.data.status==200){
				  this.total=res.data.count
				  this.listData=res.data.data
				  }
				  if(res.data.status==500){
					//document.cookie=''
					//window.open('https://oauth.tarenwang.net/api/oauth2/authorize?response_type=code&client_id=100300&redirect_uri=https://rokf.zhaouc.com/&scope=MY_PROFILE,MY_REALNAME,MY_GAMES,MY_GAME_USERS,USDK_RO1_USERINFO,USDK_RO1_SERVERS,USDK_RO1_ROLES');
					//this.$router.push({path:"/rologin"})
				  }
          if(res.data.status==501){
            this.$message({
              message:"您当前没有提交过表单！",
              offset:300
            });
          }
				})
			}else{
				this.$axios({
				  method: 'get',
				  url: '/index.php/user/User/playerforms',
				  params: {
					page:this.page
				  }
				}).then(res => {
				  if(res.data.status==200){
				  this.total=res.data.count
				  this.listData=res.data.data
				  }
				  if(res.data.status==500){
					//document.cookie=''
					//window.open('https://oauth.tarenwang.net/api/oauth2/authorize?response_type=code&client_id=100300&redirect_uri=https://rokf.zhaouc.com/&scope=MY_PROFILE,MY_REALNAME,MY_GAMES,MY_GAME_USERS,USDK_RO1_USERINFO,USDK_RO1_SERVERS,USDK_RO1_ROLES');
					//this.$router.push({path:"/rologin"})
				  }
          if(res.data.status==501){
            this.$message({
              message:"您当前没有提交过表单！",
              offset:300
            });
          }
				})
			}
		},
		an(num){
			if(num==1){
				this.s1=!this.s1
			}else if(num==2){
				this.s2=!this.s2
			}else{
				this.s3=!this.s3
			}
		},
		shou(){
			if(this.time.length==0){
				this.$message({
				  type: 'error',
				  message: '请选择时间！',
				  offset:300
				});
				return false;
			}
			if(this.csc.length==0){
				this.$message({
				  type: 'error',
				  message: '请选择工作状态！',
				  offset:300
				});
				return false;
			}
			this.$axios({
			  method: 'get',
			  url: '/index.php/user/User/searchform',
			  params: {
			    game_id:this.id,
				time:this.time,
				csc:this.csc
			  }
			}).then(res => {
			  if(res.data.status==200){
				this.total=res.data.count
				this.listData=res.data.data
			  }
			  if(res.data.status==500){
				  this.$message({
				    type: 'error',
				    message:res.data.data,
					offset:300
				  });
			  }
			})
		},
		handleChange(val){
			if(val=="近三个月记录"){
				this.time="90"
			}else if(val=="近六个月记录"){
				this.time="180"
			}else if(val=="近12个月记录"){
				this.time="360"
			}else if(val=="近24个月记录"){
				this.time="720"
			}
		},
		to(d){
			this.$axios({
			  method: 'get',
			  url: '/index.php/index/message/editnews',
			  params: {
				  mid:d.mid ,
				  type:'usernew'
			  }
			})
			this.$router.push({path:"/tracking", query:{time:d.create_time,liushui:d.turnover,isvip:d.vip,game:d.game,tname:d.tablename,jd:d.csc,mid:d.mid}})
		},
		handleChange1(val){
			if(val=="未审核"){
				this.csc="0"
			}else if(val=="已拒绝"){
				this.csc="3"
			}else if(val=="已完成"){
				this.csc="4"
			}else if(val=="问题受理中"){
				this.csc="5"
			}
		}
	  }
	}
</script>

<style>
	.red {
	      color:#ff0000;
	  }
</style>



// WEBPACK FOOTER //
// src/views/tracklist.vue